import { Phone, Mail, MapPin, Facebook, Instagram, Youtube } from "lucide-react";
import { Link } from "react-router-dom";

export const Footer = () => {
  return (
    <footer className="bg-wtr-gray text-white py-12">
      <div className="max-w-6xl mx-auto px-6">
        <div className="grid md:grid-cols-4 gap-8">
          <div>
            <h3 className="text-2xl font-bold mb-4">WTR Restoration</h3>
            <div className="text-white/80 space-y-2">
              <p className="font-semibold">Ben Jernigan</p>
              <p>Licensed Adjuster & Owner</p>
              <p>20+ Years Experience</p>
              <div className="mt-4 pt-4 border-t border-white/20">
                <p className="text-sm">
                  Fully Licensed & Insured<br />
                  IICRC Certified Firm
                </p>
              </div>
            </div>
          </div>
          
          <div>
            <h4 className="text-lg font-semibold mb-4">Services</h4>
            <ul className="space-y-2 text-white/80">
              <li><Link to="/water-damage" className="hover:text-wtr-blue-light transition-colors">Water Damage</Link></li>
              <li><Link to="/sewage-cleanup" className="hover:text-wtr-blue-light transition-colors">Sewage Cleanup</Link></li>
              <li><Link to="/mold-remediation" className="hover:text-wtr-blue-light transition-colors">Mold Remediation</Link></li>
              <li><Link to="/storm-damage" className="hover:text-wtr-blue-light transition-colors">Storm Damage</Link></li>
              <li><Link to="/freeze-damage" className="hover:text-wtr-blue-light transition-colors">Freeze / Burst Pipes</Link></li>
              <li><Link to="/structural-drying" className="hover:text-wtr-blue-light transition-colors">Structural Drying</Link></li>
              <li><Link to="/reconstruction" className="hover:text-wtr-blue-light transition-colors">Reconstruction</Link></li>
              <li><Link to="/process" className="hover:text-wtr-blue-light transition-colors">Our Process</Link></li>
            </ul>
          </div>
          
          <div>
            <h4 className="text-lg font-semibold mb-4">Service Areas</h4>
            <ul className="space-y-2 text-white/80">
              <li><Link to="/new-braunfels" className="hover:text-wtr-blue-light transition-colors">New Braunfels, TX</Link></li>
              <li><Link to="/seguin" className="hover:text-wtr-blue-light transition-colors">Seguin, TX</Link></li>
              <li><Link to="/san-marcos" className="hover:text-wtr-blue-light transition-colors">San Marcos, TX</Link></li>
              <li><Link to="/canyon-lake" className="hover:text-wtr-blue-light transition-colors">Canyon Lake, TX</Link></li>
              <li><Link to="/areas" className="hover:text-wtr-blue-light transition-colors">All Service Areas</Link></li>
            </ul>

            <h4 className="text-lg font-semibold mb-4 mt-6">Quick Links</h4>
            <ul className="space-y-2 text-white/80">
              <li><Link to="/emergency" className="hover:text-wtr-blue-light transition-colors">Emergency</Link></li>
              <li><Link to="/emergency-water-damage" className="hover:text-wtr-blue-light transition-colors">Emergency Water Damage</Link></li>
              <li><Link to="/water-extraction" className="hover:text-wtr-blue-light transition-colors">Water Extraction</Link></li>
              <li><Link to="/contents-pack-out" className="hover:text-wtr-blue-light transition-colors">Contents Pack-Out</Link></li>
              <li><Link to="/knowledge-base" className="hover:text-wtr-blue-light transition-colors">Knowledge Base</Link></li>
              <li><Link to="/insurance" className="hover:text-wtr-blue-light transition-colors">Insurance</Link></li>
              <li><Link to="/contact" className="hover:text-wtr-blue-light transition-colors">Contact</Link></li>
              <li><Link to="/company" className="hover:text-wtr-blue-light transition-colors">Company Profile</Link></li>
            </ul>
          </div>
          
          <div>
            <h4 className="text-lg font-semibold mb-4">Contact</h4>
            <div className="space-y-3">
              <div className="flex items-center space-x-3">
                <Phone className="w-5 h-5 text-wtr-blue-light" />
                <div>
                  <p className="font-semibold">830-360-2600</p>
                  <p className="text-sm text-white/70">24/7 Emergency Line</p>
                </div>
              </div>
              <div className="flex items-center space-x-3">
                <Mail className="w-5 h-5 text-wtr-blue-light" />
                <span>ben@wtrrestoration.com</span>
              </div>
              <div className="flex items-start space-x-3">
                <MapPin className="w-5 h-5 text-wtr-blue-light mt-1" />
                <div>
                  <p>457 Landre Suite A40</p>
                  <p>New Braunfels, TX 78130</p>
                </div>
              </div>
            </div>

            <div className="mt-6 pt-4 border-t border-white/20">
              <p className="text-sm text-white/80 mb-4">
                Independent. Standards-Driven. Insurance Fluent. Every mitigation protocol aligns with IICRC standards and insurance documentation requirements.
              </p>
              <div className="flex items-center gap-3">
                <a href="https://www.facebook.com/p/WTR-Restoration-100083155553498/" target="_blank" rel="noopener noreferrer" aria-label="WTR Restoration on Facebook" className="text-white/70 hover:text-wtr-blue-light transition-colors">
                  <Facebook className="w-5 h-5" />
                </a>
                <a href="https://www.instagram.com/wtrrestoration/" target="_blank" rel="noopener noreferrer" aria-label="WTR Restoration on Instagram" className="text-white/70 hover:text-wtr-blue-light transition-colors">
                  <Instagram className="w-5 h-5" />
                </a>
                <a href="https://www.youtube.com/@wtrrestoration" target="_blank" rel="noopener noreferrer" aria-label="WTR Restoration on YouTube" className="text-white/70 hover:text-wtr-blue-light transition-colors">
                  <Youtube className="w-5 h-5" />
                </a>
              </div>
            </div>
          </div>
        </div>
        
        <div className="border-t border-white/20 mt-8 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <div className="text-white/60 text-center md:text-left">
              <p>&copy; 2025 WTR Restoration LLC | Locally Owned & Operated</p>
              <div className="flex gap-4 mt-2 text-sm">
                <Link to="/privacy-policy" className="hover:text-wtr-blue-light transition-colors">Privacy Policy</Link>
                <Link to="/sitemap" className="hover:text-wtr-blue-light transition-colors">Sitemap</Link>
                <Link to="/connect" className="hover:text-wtr-blue-light transition-colors">Connect AI Assistant</Link>
              </div>
            </div>
            <div className="flex flex-wrap justify-center gap-6 text-white/80 text-sm">
              <span>IICRC Certified Firm</span>
              <span>Licensed Adjuster</span>
              <span>RIA Member</span>
              <span>20+ Years Experience</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};
